import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-4 text-center">
      <h1 className="font-display text-6xl font-bold text-primary">404</h1>
      <h2 className="mt-4 font-display text-2xl font-semibold">Página não encontrada</h2>
      <p className="mt-2 text-muted-foreground">
        A página que você está procurando não existe ou foi movida.
      </p>
      
      <div className="mt-8 flex gap-4">
        <Button variant="outline" onClick={() => window.history.back()}>
          <ArrowLeft className="h-4 w-4" />
          Voltar
        </Button>
        <Button asChild>
          <Link to="/">
            <Home className="h-4 w-4" />
            Início
          </Link>
        </Button>
      </div>
    </div>
  );
}

